import { Button, Menu, MenuItem } from "@mui/material";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDialogBetter } from "../../../hooks/useDialogBetter";
import { AGREEMENT_TYPE_KEYS } from "../../../schemas/agreements";
import { AGREEMENT_KINDS } from "../../../schemas/agreements";
import {
    AgreementConfigurationDialog,
    AgreementConfigurationDialogMode,
} from "../AgreementConfigurationDialog/AgreementConfigurationDialog";

export const AgreementModifyButton = (props) => {
    const { disable, agreement } = props;
    const { t } = useTranslation();
    const { openDialog } = useDialogBetter();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const hasBeenTransformed = useMemo(() => {
        const currentKindIndex = AGREEMENT_KINDS.findIndex(
            (k) => k.key === agreement.agreement_kind.agrekind_key,
        );

        if (currentKindIndex === -1) {
            return false;
        }

        const agreementIdsByKind = [
            agreement.reservation_agreement_id,
            agreement.preliminary_agreement_id,
            agreement.development_agreement_id,
            agreement.sale_agreement_id,
        ];

        return agreementIdsByKind.slice(currentKindIndex + 1).some((id) => id !== null);
    }, [agreement]);

    const hasBeenExtended = useMemo(() => {
        return agreement.history.some(
            (h) => h.agrelog_child_type?.agretype_key === AGREEMENT_TYPE_KEYS.Extension,
        );
    }, [agreement]);

    const handleOpenEditDialog = (mode) => {
        openDialog({
            Component: AgreementConfigurationDialog,
            componentProps: {
                mode,
                agreement,
            },
        });
        handleClose();
    };

    const handleOpenTransformDialog = () => {
        const parentKind = agreement.agreement_kind.agrekind_key;

        openDialog({
            Component: AgreementConfigurationDialog,
            componentProps: {
                mode: AgreementConfigurationDialogMode.TRANSFORM,
                parentAgreementId: agreement.id,
                parentAgreementKind: parentKind,
                agreement: agreement,
            },
        });
        handleClose();
    };

    const navMenuId = "nav-menu";
    return (
        <>
            <Button
                variant="contained"
                onClick={handleOpen}
                aria-controls={open ? navMenuId : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                disabled={disable || hasBeenTransformed}
            >
                {t("agreements.AgreementModifyButton.modifyAgreement")}
            </Button>
            <Menu
                id={navMenuId}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <MenuItem
                    onClick={() => handleOpenEditDialog(AgreementConfigurationDialogMode.EDIT)}
                >
                    {t("agreements.AgreementModifyButton.edit")}
                </MenuItem>
                <MenuItem
                    onClick={() => handleOpenEditDialog(AgreementConfigurationDialogMode.ANNEX)}
                >
                    {t("agreements.AgreementModifyButton.annex")}
                </MenuItem>
                <MenuItem
                    onClick={() =>
                        handleOpenEditDialog(AgreementConfigurationDialogMode.PROLONGATE)
                    }
                    disabled={hasBeenExtended}
                >
                    {t("agreements.AgreementModifyButton.prolongate")}
                </MenuItem>
                <MenuItem onClick={handleOpenTransformDialog}>
                    {t("agreements.AgreementModifyButton.transform")}
                </MenuItem>
            </Menu>
        </>
    );
};
